import { useState } from 'react'
import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import { returnValue, returnBlockValue } from '@/utils/op-types/helperFunctions'

import Card from '@/components/optypes/frontend/StickyPage/blocks/Card'
import Input from '@/components/optypes/headlesss-components/Input'
import Linker from '@/components/optypes/headlesss-components/Link'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const LinkBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  const [autoFocus, setAutoFocus] = useState(false)

  return (
    <Card
      cardClick={e => {
        // console.log('click card!')
        // console.log(e)
        // setAutoFocus(true)
      }}
    >
      <div className="text-2xl font-bold">
        {returnBlockValue('title', 'content', opBlocks[block], content)}
      </div>

      <div className="text-sm">
        {returnBlockValue('desc', 'content', opBlocks[block], content)}
      </div>

      <div className="mt-4 divide-y divide-gray-900 divide-opacity-30	 divide-solid">
        {returnBlockValue('links', 'content', opBlocks[block], content).map(
          (data, index) => (
            <Linker key={index} data={data.url}>
              <div
                className=" cursor-pointer my-6 "
                style={{
                  backgroundColor: returnValue(
                    'theme_cardbg',
                    opDesign,
                    pageDesign
                  ),
                  color: returnValue('theme_cardtext', opDesign, pageDesign),
                  borderColor: returnValue(
                    'theme_cardborder',
                    opDesign,
                    pageDesign
                  ),
                }}
              >
                {data.url.meta.img && (
                  <div className="w-full">
                    <img
                      src={data.url.meta.img}
                      alt=""
                      className="w-full mb-3 rounded shadow"
                    />
                  </div>
                )}
                <div className="w-full">
                  <div className="font-bold text-xl mb-1">
                    {data.url.meta.title}
                  </div>
                  <div className="text-xs">{data.url.meta.desc}</div>
                  <div className="font-medium truncate text-sm text-blue-400 mt-1">
                    {data.url.url}
                  </div>
                </div>
              </div>
            </Linker>
          )
        )}
      </div>
    </Card>
  )
}

export default LinkBlock
